import React, { Fragment } from "react";
import CoreComponent from "../../../../../framework/component/CoreComponent";
import CoreContainer from "../../../../../framework/container/CoreContainer";
import ComponentFactory from "../../../../../framework/factory/ComponentFactory";
import ContainerFactory from "../../../../../framework/factory/ContainerFactory";
import layout from "../../../../../framework/Layout";
import OrderHelper from "../../../../../helper/OrderHelper";
import OrderItemService from "../../../../../service/sales/order/OrderItemService";
import ProductTypeConstant from "../../../../constant/ProductTypeConstant";

export class OrderItem extends CoreComponent {
  static className = "OrderItem";

  /**
   * Get display price
   * @param price
   * @param order
   * @return {*}
   */
  getDisplayPrice(price, order) {
    return OrderHelper.formatPrice(price, order);
  }

  /**
   * get option detail like as custom, bundle, configurable option
   * @param item
   * @return {*}
   */
  displayOption(item) {
    let productOptions =
      item.product_options && !Array.isArray(item.product_options)
        ? JSON.parse(item.product_options)
        : null;
    if (!productOptions) {
      return "";
    }
    let result = [];
    if (
      item.product_type === ProductTypeConstant.SIMPLE ||
      item.product_type === ProductTypeConstant.VIRTUAL
    ) {
      result.push(...this.displayCustomOption(productOptions));
    }
    if (item.product_type === ProductTypeConstant.CONFIGURABLE) {
      result.push(...this.displayConfigurableOption(productOptions));
      result.push(...this.displayCustomOption(productOptions));
    }

    if (item.product_type === ProductTypeConstant.GIFT_CARD) {
      result.push(...this.displayGiftCardOption(productOptions));
    }

    return result.join(", ");
  }

  displayCustomOption(productOptions) {
    return OrderItemService.getCustomOption(productOptions);
  }

  displayConfigurableOption(productOptions) {
    return OrderItemService.getConfigurableOption(productOptions);
  }

  displayGiftCardOption(productOptions) {
    let { order, t } = this.props;
    return OrderItemService.getGiftCardOption(productOptions, order, t);
  }

  isShowShipped() {
    let { order, item } = this.props;
    if (!item.qty_shipped) {
      return false;
    }
    if (item.product_type === ProductTypeConstant.BUNDLE) {
      return !OrderItemService.isShipSeparately(item, order);
    } else if (OrderItemService.getParentItem(item, order)) {
      let parent = OrderItemService.getParentItem(item, order);
      return (
        parent.product_type === ProductTypeConstant.BUNDLE &&
        OrderItemService.isShipSeparately(parent, order)
      );
    }
    return true;
  }

  canShowPriceInfo() {
    let { order, item } = this.props;
    return (
      (OrderItemService.getParentItem(item, order) &&
        OrderItemService.isChildrenCalculated(item, order)) ||
      (!OrderItemService.getParentItem(item, order) &&
        !OrderItemService.isChildrenCalculated(item, order))
    );
  }

  canShowInvoiceRefundCancel() {
    let { order, item } = this.props;
    if (item.product_type === ProductTypeConstant.BUNDLE) {
      return !OrderItemService.isChildrenCalculated(item, order);
    } else if (OrderItemService.getParentItem(item, order)) {
      let parent = OrderItemService.getParentItem(item, order);
      return (
        parent.product_type === ProductTypeConstant.BUNDLE &&
        OrderItemService.isChildrenCalculated(parent, order)
      );
    }
    return true;
  }

  /**
   * template
   * @returns {*}
   */
  template() {
    let { order, item } = this.props;
    // let isHolded = order.status === StatusConstant.STATUS_HOLDED;
    // let canShowInvoiceRefundCancel = this.canShowInvoiceRefundCancel();
    let numberChest = item.additional_data;
    let squadColor = item.ext_order_item_id;
    console.log(numberChest,'NUMBERCHESTORDEMITEM');
    console.log(squadColor,'SQUADCOLORORDERITEM')

    if (item.parent_item_id) {
      let parent = order.items.find(
        (x) => Number(x.item_id) === Number(item.parent_item_id)
      );
      if (parent && parent.product_type !== ProductTypeConstant.BUNDLE) {
        return null;
      }
    }

    return (
        <Fragment>
          {item.associated_customers &&
            item.associated_customers.map((customer, idx) => (
              <div key={idx} className="associated-customers">
                {/* <span className="attribute-label">
                  {this.props.t("Participant")} {idx + 1}:
                </span>
                <span className="attribute-value">{customer.firstname}</span>
                <span className="attribute-value">{customer.lastname}</span>

                <div className="additional-info">
                  <span className="attribute-label">
                    {this.props.t("Data de Nascimento:")}
                  </span>
                  <span className="attribute-value">
                    {customer.dob || "N/A"}
                  </span>
                </div>
                <div className="additional-info">
                  <span className="attribute-label">
                    {this.props.t("Documento:")}
                  </span>
                  <span className="attribute-value">
                    {customer.taxvat || "N/A"}
                  </span>
                </div> */}
                {/* <div className="additional-data">
                  <span className="attribute-label">
                    {this.props.t("Nº de Peito:")}
                  </span>
                  <span className="attribute-value">{numberChest}</span>
                </div> */}
                {/* <div
                  className="squadColor"
                  style={getsquadColorStyle(squadColor)}
                >
                  <span className="attribute-label">
                    {this.props.t("Pelotão:")}
                  </span>
                  <span className="attribute-value">{squadColor}</span>
                </div> */}
              </div>
            ))}

          <div className="name">{item.name}</div>
          <div className="option">{this.displayOption(item)}</div>
          {/* <div className="item-status">
            <span>
              {this.props.t("Ordered: {{qty}}", {
                qty: NumberHelper.formatDisplayGroupAndDecimalSeparator(
                  item.qty_ordered
                ),
              })}
            </span>
            {!isHolded ? (
              <Fragment>
                {canShowInvoiceRefundCancel && item.qty_invoiced ? (
                  <span>
                    {this.props.t("Invoiced: {{qty}}", {
                      qty: item.qty_invoiced
                        ? NumberHelper.formatDisplayGroupAndDecimalSeparator(
                            item.qty_invoiced
                          )
                        : 0,
                    })}
                  </span>
                ) : null}
                {this.isShowShipped() ? (
                  <span>
                    {this.props.t("Shipped: {{qty}}", {
                      qty: item.qty_shipped
                        ? NumberHelper.formatDisplayGroupAndDecimalSeparator(
                            item.qty_shipped
                          )
                        : 0,
                    })}
                  </span>
                ) : null}
                {canShowInvoiceRefundCancel && item.qty_refunded ? (
                  <span>
                    {this.props.t("Refunded: {{qty}}", {
                      qty: item.qty_refunded
                        ? NumberHelper.formatDisplayGroupAndDecimalSeparator(
                            item.qty_refunded
                          )
                        : 0,
                    })}
                  </span>
                ) : null}
                {canShowInvoiceRefundCancel && item.qty_canceled ? (
                  <span>
                    {this.props.t("Canceled: {{qty}}", {
                      qty: item.qty_canceled
                        ? NumberHelper.formatDisplayGroupAndDecimalSeparator(
                            item.qty_canceled
                          )
                        : 0,
                    })}
                  </span>
                ) : null}
              </Fragment>
            ) : null}
          </div> */}
          {item.os_pos_custom_price_reason ? (
            <div className="custom-reason">
              <span>{item.os_pos_custom_price_reason}</span>
            </div>
          ) : (
            ""
          )}
          <div className={"order-item-detail-after"}>
            {layout("order")("order_detail")("detail_content")("order_item")(
              "order_item_itemdetail_after"
            )()(this, item)}
          </div>
        </Fragment>
      );
  }
}

class OrderItemContainer extends CoreContainer {
  static className = "OrderItemContainer";
}

/**
 * @type {OrderItem}
 */
export default ContainerFactory.get(OrderItemContainer).withRouter(
  ComponentFactory.get(OrderItem)
);

// WEBPACK FOOTER //
// ./src/view/component/order/order-detail/detail-content/OrderItem.js



// WEBPACK FOOTER //
// ./src/view/component/order/order-detail/detail-content/OrderItem.js